import { Component, Input, OnInit } from '@angular/core';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { IReason } from '../../../reasons/data/reason';
import { ManagerReasonService } from 'src/app/pages/reasons/services/manager-reason.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { EReasonType } from '../../../reasons/data/reason-type.enum';

@Component({
  selector: 'app-tab-add-reason',
  templateUrl: './tab-add-reason.component.html',
  styleUrls: ['./tab-add-reason.component.scss']
})
export class TabAddReasonComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;

  @Input() companyId?: string;
  @Input() partnerId?: string;

  formGroup = new UntypedFormGroup({
    reasonSelected: new UntypedFormControl([]),
    cancellationReasonsSelected: new UntypedFormControl([]),
  });

  reasonOptions: IReason[] = [];
  cancellationReasonsOptions: IReason[] = [];

  constructor(
    private readonly managerReasonService: ManagerReasonService,
    private readonly toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.managerReasonService.listAllReasons(this.partnerId).subscribe((response) => {
      this.reasonOptions = response.data.filter((reason) => reason.type === EReasonType.Atendimento);
      this.cancellationReasonsOptions = response.data.filter((reason) => reason.type === EReasonType.Cancelamento);
    });

    if (this.companyId) {
      this.managerReasonService.getCompanyReasons(this.companyId).subscribe((response) => {
        this.formGroup.get('reasonSelected')?.patchValue(response.data
          .filter((reason) => reason.type === EReasonType.Atendimento).map((reason) => reason.id));
        this.formGroup.get('cancellationReasonsSelected')?.patchValue(response.data
          .filter((reason) => reason.type === EReasonType.Cancelamento).map((reason) => reason.id));
      });
    }
  }

  addReasonToCompany(): void {
    const reasons = [...this.formGroup.get('reasonSelected')?.value, ...this.formGroup.get('cancellationReasonsSelected')?.value];

    const body = {
      companyId: this.companyId!,
      reasonIds: reasons,
    }
    this.managerReasonService.addReasonToCompany(body).subscribe((response) => {
      if (response.isSucceed) {
        this.toastService.toast('Motivos adicionados com sucesso');
      }
    })
  }
}
